module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[76]441.c68c5a0.woff2";